<span class="material-symbols-outlined" [class.noMove]="noMove" [class.fill]="fill" [style.font-size]="'1em'" style="color: inherit">
    {{ icon }}
</span>